import { AppModule } from './app/app.module';

import './third_parties';

import { importProvidersFrom, InjectionToken, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { INTERCOM_APP_ID } from '@teammood/shared/util/intercom';
import { getSupportedLocale } from '@teammood/shared/util/locale';
import { STRIPE_TOKEN } from '@teammood/shared/util/stripe';
import { AppComponent } from './app/app.component';
import { fetchConfig } from './boot';
import { bootstrapApplication } from "@angular/platform-browser";
import { GIF_PROVIDER_ID } from "./lib/shared/ui/gifpicker/gifs.service";

fetchConfig()
  .then(async (config) => {

        await bootstrapApplication(AppComponent, {
          providers: [
              provideZoneChangeDetection(),{ provide: LOCALE_ID, useValue: getSupportedLocale(config.lang) },
              { provide: INTERCOM_APP_ID, useValue: config.intercomAppId },
              { provide: STRIPE_TOKEN, useValue: config.stripeToken },
              { provide: GIF_PROVIDER_ID, useValue: config.gifProvider },
              importProvidersFrom(AppModule)
          ]
        })
  })
  